import type { IBondScreenerView, TBondScreenerFiltersShape } from '@/creditflowresearch/domain/vo/Bondscreener';

export interface IBondScreenerViewSavePayload<TFilters extends TBondScreenerFiltersShape> {
  columns: string[],
  filters: TFilters,
}

interface IApplyBondScreenerViewActions<TFilters extends TBondScreenerFiltersShape> {
  applyExternalColumns: (ids: string[]) => void,
  resetColumns: () => void,
  resetFiltersTo: (filters: TFilters) => void,
  resetFilters: () => void,
}

export const applyBondScreenerView = <
  TFilters extends TBondScreenerFiltersShape,
  TApiFilters extends TBondScreenerFiltersShape,
>(
  view: IBondScreenerView<TApiFilters> | null,
  { applyExternalColumns, resetColumns, resetFiltersTo, resetFilters }: IApplyBondScreenerViewActions<TFilters>,
  mapViewFiltersToDraft: (viewFilters: Partial<TApiFilters> | null) => TFilters,
): void => {
  if (!view) {
    resetColumns();
    resetFilters();
    return;
  }

  applyExternalColumns(view.columns);
  resetFiltersTo(mapViewFiltersToDraft(view.filters));
};

export const buildBondScreenerViewSavePayload = <
  TFilters extends TBondScreenerFiltersShape,
  TApiFilters extends TBondScreenerFiltersShape,
>(
  { columns, filters }: IBondScreenerViewSavePayload<TFilters>,
  adaptFiltersToRequestFormat: (filters: TFilters) => TApiFilters,
): IBondScreenerViewSavePayload<TApiFilters> => ({
  columns,
  filters: adaptFiltersToRequestFormat(filters),
});
